import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MotivosRechazo } from '../../cliente/motivosRechazo/motivosRechazo.model';
import { BackendService } from '../../core/backend.service';
import { Cliente } from '../../cliente/cliente.model';
import { AprobacionDocumento } from '../validar-documentacion/aprobacionDocumento.model';

@Component({
  selector: 'app-select-motivo-rechazo',
  templateUrl: './select-motivo-rechazo.component.html',
  styleUrls: ['./select-motivo-rechazo.component.scss']
})
export class SelectMotivoRechazoComponent implements OnInit {

  @Input() documento: AprobacionDocumento;
  @Output() onSelect: EventEmitter<AprobacionDocumento> = new EventEmitter<AprobacionDocumento>();
  private motivosRechazo: MotivosRechazo[] = [];
  constructor(
    private backendService: BackendService
  ) { }

  ngOnInit() {
    this.getMotivosRechazo();
  }

  async getMotivosRechazo() {
    this.motivosRechazo = await this.backendService.get(MotivosRechazo, Cliente.path + 'motivosrechazos/all', null).toPromise();
  }
  selected(index: number) {
    this.documento.motivoRechazo.description = this.motivosRechazo[index].description;
    this.onSelect.emit(this.documento);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/select-motivo-rechazo/select-motivo-rechazo.component.ts